import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {WindowLocationUtil} from '@mintdata-wsp/common/util/WindowLocationUtil';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {BaseRoute} from '@mintdata-wsp/wsp/ui/routes/BaseRoute';
import * as React from 'react';
import {Redirect, RouteComponentProps, RouteProps} from 'react-router';
import {Routing} from './Routing';

export interface IAuthRouteProps extends RouteProps
{
    page:React.ComponentClass;
}

export class AuthRoute extends React.Component<IAuthRouteProps, any>
{
    public render()
    {
        return <BaseRoute {...this.props} renderRoute={this._renderRoute} />;
    }

    private _renderRoute = (routeComponentProps:RouteComponentProps<any>):JSX.Element =>
    {
        const ProtectedPage:any = this.props.page;
        const isLoggedIn = controllers.user.isLoggedIn();

        if (ConfigUtil.useAppLogin())
            return isLoggedIn ?
                <ProtectedPage {...routeComponentProps} /> :
                <Redirect to={{pathname: Routing.paths().login(), state: {from: routeComponentProps.location}}} />;

        if( !isLoggedIn )
            WindowLocationUtil.fullRedirectTo(
                WindowLocationUtil.getRootDomain(),
                `/login#redirectUrl=${encodeURIComponent(String(window.location))}`
            );
        else
            return <ProtectedPage {...routeComponentProps} />;
    };
}
